<template>
  <div class="base-tooltip">
    <div v-if="show" class="tooltip-prompt" :style="{left: left + 'px'}">{{tips}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tips: String,
    show: Boolean,
    left: Number,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.base-tooltip{
  position: relative;
  .tooltip-prompt{
    position: absolute;
    bottom: 100%;
    left: 0;
    margin-bottom: 8px;
    background-color: rgba(47, 51, 61, 0.94);
    padding: 4px 8px;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
    white-space: nowrap;
    border-radius: 4px;
    &::after{
      content: "";
      position: absolute;
      top: 100%;
      left: 12px;
      border-color: rgba(47, 51, 61, 0.94) transparent transparent transparent;
      border-width: 4px;
      border-style: solid;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/base/base-tooltip.vue